import { openQuickshop } from '../helpers';

/**
 * Listens for external scripts to open the quickshop modal via a custom event.
 *
 * Dispatch from any script on the page:
 *   document.dispatchEvent(
 *     new CustomEvent('quickshop:open', {
 *       detail: { productUrl: '/products/my-handle' },
 *     })
 *   );
 *
 * @param {string} detail.productUrl - Shopify product path (e.g. /products/handle)
 */
export default function initQuickshop() {
  // On PDPs the quickshop section server-renders the current product. Nothing
  // reads that copy (openQuickshop always fetches), and it duplicates every
  // id/label pairing in the main product form.
  document.querySelector('[data-quickshop-section] [data-product]')?.remove();

  document.addEventListener('quickshop:open', event => {
    const { productUrl } = event.detail ?? {};
    if (productUrl) {
      openQuickshop(productUrl);
    }
  });
}
